import script from "./FixtureBookMarketOdd.vue?vue&type=script&setup=true&lang=js"
export * from "./FixtureBookMarketOdd.vue?vue&type=script&setup=true&lang=js"

import "./FixtureBookMarketOdd.vue?vue&type=style&index=0&id=8cf68450&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8cf68450"]])

export default __exports__